import React, { useState, } from 'react'
import { Row, Col, } from 'reactstrap'
import { PROGRAM_SEARCH_TYPES, } from '../../../constants/other'
import PropTypes from 'prop-types'

function ProgramSearchDescription({
  activeProgramType = null,
}: {activeProgramType: any}) {
  const [ description, setDescription ] = useState<string>('');

  React.useEffect(() => {
    if (activeProgramType) {
      const currentType = PROGRAM_SEARCH_TYPES.filter(t => t.name === activeProgramType)[0];
      setDescription(currentType.description);
    }
  }, [ activeProgramType, ], )

  return (
    <Row>
      <Col xs={12}>
        <h2 className={'mb-1'}>{description ? description + '.' : ''}</h2>
        <h5 className={'heading-5'} style={{ paddingTop: '1em', }}>Click the Search button to find programs for you.</h5>
        <h5 className={'heading-5'} style={{ paddingTop: '1em', }}>Looking for resources that can help you participate in these experiences? <a href={`${window.location.href}?es=1`}>Click here.</a></h5>
      </Col>
    </Row>
  )
}

ProgramSearchDescription.propTypes = {
  activeProgramType: PropTypes.string,
}

export default ProgramSearchDescription
